package com.gavino.nutritrack

actual class HealthConnectManager actual constructor() {
    actual suspend fun isAvailable(): Boolean = false
    actual suspend fun requestPermissions(): Boolean = false
    actual suspend fun readActiveCaloriesForDay(offsetDays: Int): Int = 0
    actual suspend fun writeWeight(weightKg: Double) {}
    actual suspend fun writeNutritionToday(calories: Double, carbsGrams: Double, proteinGrams: Double, fatGrams: Double) {}
}
